import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { getWrapState } from '../store/selectors/getWrapState';
import Wrap from '../Wrap';
import initContainerData from 'bdata-react-component/lib/store/initContainerData';
import wrapReducer from '../store/reducers/wrap';
import teamStatsGameReducer from '../../TeamComparison/store/reducers/teamStatsGame';
import teamStatsSeasonAllTimeReducer from '../../TeamComparison/store/reducers/teamStatsSeasonAllTime';
import morecoverageReducer from '../../MoreCoverage/store/reducers/morecoverage';
import { routes as videoCarouselRoutes } from '../../VideoCarousel/containers/VideoCarouselDataContainer';
import { routes as recapRoutes } from '../../Recap/RecapDataContainer';
import { routes as topPerformerRoutes } from '../../TopPerformers/containers/TopPerformersDataContainer';
import { routes as morecoverageRoutes } from '../../MoreCoverage/containers/MoreCoverageDataContainer';
import { routes as potgRoutes } from '../../PlayerOfTheGame/containers/PlayerOfTheGameDataContainer';

import ErrorBoundaryWrapper from '@gameday/components/ErrorFallback/ErrorBoundaryWrapper';

initContainerData.register({
    reducers: {
        wrap: wrapReducer,
        teamStatsGame: teamStatsGameReducer,
        morecoverage: morecoverageReducer
    }
});

const routes = [{
    path: '/',
    exact: false,
    routes: [
        ...videoCarouselRoutes,
        ...recapRoutes,
        ...topPerformerRoutes,
        ...morecoverageRoutes,
        ...potgRoutes
    ]
}];

const WrapContainer = ({
    viewType
}) => {
    const wrapState = useSelector(getWrapState);

    return (
        <ErrorBoundaryWrapper componentName='Wrap'>
            <Wrap
                viewType={ viewType }
                { ...wrapState }
            />
        </ErrorBoundaryWrapper>
    );
};

WrapContainer.propTypes = {
    viewType: PropTypes.string
};

export default WrapContainer;

export { routes };
